import Header from './components/header/Header'
import AppRoute from "./routing/AppRoute";

function App() {
  return (
      <div className="App">
        <AppRoute/>
      </div>
  );
}

export default App;
